import { c as _c } from "react/compiler-runtime";
type InputProps = {
  readonly value: string;
  readonly placeholder?: string | undefined;
  readonly showSearchIcon?: boolean | undefined;
  readonly disabled?: boolean | undefined;
  readonly theme?: "dark" | "light" | undefined;
  readonly size?: "sm" | "md" | undefined;
  readonly onChange: (newV: string | null) => void;
  readonly onFocusChange?: ((focus: boolean) => void) | undefined;
};
type NumberInputProps = InputProps & {
  readonly inputType: "number";
  readonly minValue?: number | undefined;
  readonly maxValue?: number | undefined;
};
type TextInputProps = InputProps & {
  readonly inputType?: "text" | undefined;
  readonly maxLength?: number | undefined;
};
export default function CommonInput(props) {
  const $ = _c(26);
  const {
    value,
    placeholder,
    showSearchIcon,
    onChange,
    onFocusChange,
    inputType: t0,
    disabled: t1,
    theme: t2,
    size: t3
  } = props;
  const inputType = t0 === undefined ? "text" : t0;
  const disabled = t1 === undefined ? false : t1;
  const theme = t2 === undefined ? "dark" : t2;
  const size = t3 === undefined ? "md" : t3;
  let t4;
  if ($[0] !== onChange || $[1] !== props.inputType || $[2] !== props.maxLength || $[3] !== props.maxValue || $[4] !== props.minValue) {
    t4 = e => {
      if (e.target.value === "") {
        onChange(null);
        return;
      }
      if (props.inputType === "number") {
        const numericValue = parseFloat(e.target.value);
        if (isNaN(numericValue)) {
          onChange(null);
          return;
        }
        if (props.minValue !== undefined && numericValue < props.minValue) {
          onChange(props.minValue.toString());
          return;
        }
        if (props.maxValue !== undefined && numericValue > props.maxValue) {
          onChange(props.maxValue.toString());
          return;
        }
      } else {
        if (props.inputType === "text") {
          if (props.maxLength !== undefined && e.target.value.length > props.maxLength) {
            onChange(e.target.value.substring(0, props.maxLength));
            return;
          }
        }
      }
      onChange(e.target.value);
    };
    $[0] = onChange;
    $[1] = props.inputType;
    $[2] = props.maxLength;
    $[3] = props.maxValue;
    $[4] = props.minValue;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onInput = t4;
  const min = props.inputType === "number" ? props.minValue : undefined;
  const max = props.inputType === "number" ? props.maxValue : undefined;
  const maxLength = props.inputType === "text" ? props.maxLength : undefined;
  let t5;
  if ($[6] !== showSearchIcon) {
    t5 = showSearchIcon && <svg className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-3 tw-h-5 tw-w-5 tw-text-iron-300" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" /></svg>;
    $[6] = showSearchIcon;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] !== onFocusChange) {
    t6 = () => onFocusChange && onFocusChange(true);
    t7 = () => onFocusChange && onFocusChange(false);
    $[8] = onFocusChange;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  const t8 = `${showSearchIcon ? "tw-pl-11" : ""} ${disabled ? "tw-opacity-40" : ""} ${theme === "dark" ? "tw-bg-iron-900" : "tw-bg-iron-800"} ${size === "md" ? "tw-py-2.5" : "tw-py-2"} tw-form-input tw-appearance-none tw-block tw-w-full tw-rounded-lg tw-border-0 tw-pr-3 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-600 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-bg-transparent focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out`;
  let t9;
  if ($[11] !== disabled || $[12] !== inputType || $[13] !== max || $[14] !== maxLength || $[15] !== min || $[16] !== onInput || $[17] !== placeholder || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== value) {
    t9 = <input type={inputType} placeholder={placeholder} value={value} min={min} max={max} maxLength={maxLength} disabled={disabled} onChange={onInput} onFocus={t6} onBlur={t7} className={t8} />;
    $[11] = disabled;
    $[12] = inputType;
    $[13] = max;
    $[14] = maxLength;
    $[15] = min;
    $[16] = onInput;
    $[17] = placeholder;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = value;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t5 || $[24] !== t9) {
    t10 = <div className="tw-relative">{t5}{t9}</div>;
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}